var globalVar = {}

export default globalVar